export default __webpack_public_path__ + "static/media/sendFiles.733ea99b.png";